<template>
  <div class="wrapper">
    <nav-vertical />
    <transition name="fade-in">
      <child />
    </transition>
    <br /> 
  </div>
</template> 
<script>
export default {
  name: "Default"
};
</script> 

 